module.exports = __webpack_public_path__ + "static/media/chess-king.95b83f1f.svg";